import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/video_record_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  account_id_eq: {
    column_type: 'belongs_to',
    column_name: 'account',
    extra: {
      model_name: 'Account',
    },
    model_name: 'VideoRecord',
  },
  account: {
    column_type: 'belongs_to',
    column_name: 'account',
    extra: {
      model_name: 'Account',
    },
    model_name: 'VideoRecord',
  },
  fund_id_eq: {
    column_type: 'belongs_to',
    column_name: 'fund',
    extra: {
      model_name: 'Fund',
    },
    model_name: 'VideoRecord',
  },
  fund: {
    column_type: 'belongs_to',
    column_name: 'fund',
    extra: {
      model_name: 'Fund',
    },
    model_name: 'VideoRecord',
  },
  status_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'VideoRecord',
      options: ['pending', 'auditing', 'finished', 'rejected'],
    },
    model_name: 'VideoRecord',
    column_name: 'status',
  },
}
export const formColumnsConfig = {
  'self': {
    'account_id': { required: true, disabledUpdate: false },
    'fund_id': { required: true, disabledUpdate: false },
    'investment_principal': { required: false, disabledUpdate: false },
    'status': { required: false, disabledUpdate: false },
    'last_investment_date': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('VideoRecord', columns), filterColumnsExtend)
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('VideoRecord', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
